import { ThemeOptions } from '@mui/material';
import { createTheme, defaultThemeOptions } from '@orbis-systems/orbis-react-toolkit';
import { cloneDeep, merge } from 'lodash';
import { DeepPartial } from 'utility-types';

declare module '@mui/material/styles/createTheme' {
    interface Dimens {
        sidebarWidth: number;
        drawerWidth: number;
    }

    interface Theme {
        dimens: Dimens;
    }

    interface ThemeOptions {
        dimens?: Dimens;
    }
}

const themeOptions: DeepPartial<ThemeOptions> = {
    dimens: {
        sidebarWidth: 364,
        drawerWidth: 268,
    },
    // Make MUI zIndex compatible with shadcn/ui
    zIndex: {
        mobileStepper: 40,
        fab: 45,
        speedDial: 45,
        appBar: 46,
        drawer: 47,
        modal: 48,
        snackbar: 49,
        tooltip: 50,
    },
};

export const defaultTheme = createTheme(
    merge<ThemeOptions, DeepPartial<ThemeOptions>>(cloneDeep(defaultThemeOptions), {
        ...themeOptions,
        palette: {
            ...defaultThemeOptions.palette,
            background: {
                default: '#fff',
                paper: '#fff',
            },
        },
        shadows: Array(25).fill('0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)'),
    }),
);

export const darkTheme = createTheme(
    merge<ThemeOptions, DeepPartial<ThemeOptions>>(cloneDeep(defaultThemeOptions), {
        ...themeOptions,
        palette: {
            mode: 'dark',
            primary: {
                main: '#2196f3',
            },
            secondary: {
                main: '#e54949',
            },
            background: {
                default: '#000',
                paper: '#171717',
            },
        },
        components: {
            MuiPaper: {
                styleOverrides: {
                    root: {
                        backgroundImage: 'none',
                    },
                },
            },
        },
    }),
);
